export default __webpack_public_path__ + "static/media/analysis.9edf63f5.png";